import { Link } from "@tanstack/react-router";
import { MapPinOffIcon } from "lucide-react";

import { Brand } from "../components/Brand";
import { buttonVariants } from "../components/ui/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "../components/ui/empty";

export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-background px-5 py-12">
      <Empty className="max-w-lg">
        <EmptyHeader>
          <Brand className="mb-5" />
          <EmptyMedia variant="icon">
            <MapPinOffIcon aria-hidden="true" />
          </EmptyMedia>
          <p className="mono-label m-0">404</p>
          <EmptyTitle className="font-heading text-2xl">That page isn’t in this box.</EmptyTitle>
          <EmptyDescription>
            Return to your workspace and choose one of your available tools.
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Link className={buttonVariants({ variant: "default" })} to="/">
            Go to workspace
          </Link>
        </EmptyContent>
      </Empty>
    </main>
  );
}
